import React from "react";
import { motion } from "framer-motion";
import SectionHeader from "../common/sectionHeader";
import INFO from "../../data/user";
import "./styles/journeyTimeline.css";

const JourneyTimeline = () => {
	return (
		<section className="journey-section">
			<SectionHeader
				tag="Trajectory"
				title="Engineering"
				highlight="Journey & Roadmap"
				subtitle="Evolution from algorithm mastery and software internships to enterprise systems engineering and distributed architectures."
			/>

			<div className="journey-timeline-container">
				{INFO.journey.map((step, index) => (
					<motion.div
						key={index}
						className="journey-step-card"
						initial={{ opacity: 0, x: -16 }}
						whileInView={{ opacity: 1, x: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.35, delay: index * 0.1 }}
					>
						<span className="journey-year">{step.year}</span>
						<div className="journey-title">{step.title}</div>
						<p className="journey-desc">{step.description}</p>
					</motion.div>
				))}
			</div>
		</section>
	);
};

export default JourneyTimeline;
